const SALUTATION_OPTIONS = ['Mr.', 'Mrs.', 'Ms.'] as const;

const PANEL_DESCRIPTION =
  'Make sure your name and date of birth match your passport' +
  ' (including middle name, if applicable). Changing these' +
  ' fields may affect the accuracy of your records.';

const CONFIRM_MODAL_BODY =
  'Your name and date of birth must match your passport exactly.' +
  ' Changing it may affect official documents (e.g., certificates).' +
  ' Please review carefully before saving.';

export { CONFIRM_MODAL_BODY, PANEL_DESCRIPTION, SALUTATION_OPTIONS };
